import DiseaseRiskmap from "./DiseaseRiskmap";

export default DiseaseRiskmap;